import React, {
} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import {
    BooleanGridColumnType,
    ActionButtons,
    ActionButtonTypes,
    buildActionButton
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {FilterBar} from "../../../components/Grid/FilterBar";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";

const ParkingZoneListView = () => {

	const navigate = useNavigate();
	const repository = new ParkingZoneRepository();
	const {t}  = useTranslation();

	const sortOptions = [
      {
        value: 'Id|desc',
        label: t('Newest first')
      },
      {
        value: 'Id|asc',
        label: t('Oldest first')
      },
      {
        value: 'Name|asc',
        label: t('Name') + ' (A-Z)'
      },
      {
        value: 'Name|desc',
        label: t('Name') + ' (Z-A)'
      }
    ];

    const handleEditItemClick = (event) => {
	    navigate("/app/parking-zones/" + event.Id);
    }

	const { items, totalCount, itemsOnPage, onDeleteHandler, onEditHandler, onPage, isSearching, onFilterChangedHandler , onSortChangedHandler, filter, sort, updateGrid } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: sortOptions[0].value });

	const columns = [
      { field: 'Id', headerName: t('ID'), width: 70, sortable: false },
      { field: 'Name', headerName: t('Name'), width: 130, sortable: false  },
      { field: 'IntegrationId', headerName: t('Integration Id'), width: 130, sortable: false},
      { field: 'LongParkingTimeMinutes', headerName: t('Long parking threshold'), width: 200, sortable: false },
      {
          field: 'IsActive',
          headerName: t('Active'),
          width: 100,
          sortable: false,
          ... BooleanGridColumnType
      },
      {
          headerName: t('Actions'),
          field: 'edit',
          ...ActionButtons([buildActionButton(ActionButtonTypes.EDIT, t("Edit"), onEditHandler), buildActionButton(ActionButtonTypes.DELETE, t("Delete"), onDeleteHandler)])
      }
    ];

	return (
	    <GridSkeleton title={t("Parking zones")}
                      isSearching={isSearching}
                      header={(<Header onRefresh={updateGrid} />)}
                      filter={(<FilterBar sortOptions={sortOptions} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort}/>)}
                      grid={(<DataGrid
                                   disableMultipleSelection={true}
                                   disableColumnFilter
                                   rows={items()}
                                   rowCount={totalCount()}
                                   columns={columns}
                                   pageSize={itemsOnPage}
                                   paginationMode="server"
                                   sortingMode="server"
                                   disableColumnSelector={true}
                                   disableSelectionOnClick={true}
                                   disableColumnMenu={true}
                                   onPageChange={onPage}
                                   rowsPerPageOptions={[itemsOnPage]}
                                   hideFooterSelectedRowCount={true}
                         />)}
        />

	);
};

export default ParkingZoneListView;
